
<div class="find-inventory-container">
  <!-- Search Bar -->
  <div class="input-container flex flex-row justify-around items-center">
    <!-- Icons and Input -->
    <div @click="search" class="flex items-center gap-1">
      <img src="@/images/header/search-II.png" alt="search" />
      <img v-if="loading" class="animate-spin h-4" src="@/images/spinner.svg" alt="Loading">
    </div>
    <input
      @keyup.enter="search"
      v-model="query"
      @click="coordinates = null"
      :class="{ 'is-danger': error }"
      class="bg-transparent w-full focus:ring-0 focus:outline-none"
      type="search"
      placeholder="Find Inventory"
    />
    <toggle @toggleValue="setToggleOption" />
  </div>
  <!-- Search Results -->
  <div class="search-results-container">
    <!-- Error Message -->
    <div v-if="error" class="help py-1 text-center bg-white text-red-500 border rounded-md">
      {{ error }}
      <b><a @click.prevent="resetSearch()">Try Again</a></b>
    </div>
    <!-- Cities List -->
    <div v-if="cities.length" role="menu" class="mt-1 border rounded-md">
      <div class="dropdown-content modal-card-body">
        <p class="dropdown-item"><b>We found multiple results...</b></p>
        <a
          v-for="city in cities"
          :key="city.id"
          :href="cityPath(city.node)"
          class="dropdown-item"
        >
          {{ city.node.name }}, {{ city.node.stateId | upcase }}
        </a>
      </div>
    </div>
  </div>
</div>
